const showKey = {
  murongziying: "murongziying"
  ,kobe: "kobe"
  ,wusheng: "wusheng"
  ,xzNot: "xzNot"
  ,xzing: "xzing"
  ,xzSuccess: "xzSuccess"
  ,xzWarning: "xzWarning"
  ,xzError: "xzError"
}
export default showKey



// WEBPACK FOOTER //
// ./src/cnConst/showKey.js